'use strict';

export enum MediaType {
  Application = 'Application',
  Audio = 'Audio',
  Image = 'Image',
  Text = 'Text',
  Video = 'Video',
}
